import { keyframes } from "@emotion/react";

export interface EmployeeModel {
  id: number,
  name: string,
  email: string,
  shift: string,
  designation: string,
  department: string,
  branch: string,
  payrollCompany: string,
  usCompany: string,
  status: string,
  presence: string,
  avatarUrl: string,
  empCode: string,
  phone: string,
  isOnline?: boolean,
  profileCompletion?: IProfileCompletion;
}

interface IProfileCompletion{
  totalPercentage:number,
  tabs:IProfileTabs
}

interface IProfileTabs{
  bank:number,
  documents:number,
  education:number,
  employer:number,
  family:number,
  personal:number
}


export interface EmployeeCardProps {
  employee: EmployeeModel;
  statusDD: StatusDD[];
  reload?: boolean;
  setReload?: (reload: boolean) => void;
}

export interface StatusDD {
  id: number;
  employeeStatus: string;
}

export const ripple = keyframes`
  0% {
    transform: scale(0.8);
    opacity: 0.8;
  }
  100% {
    transform: scale(2.2);
    opacity: 0;
  }
`;